import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Button } from 'fundamental-react';

export class DefaultPage extends Component {
  static propTypes = {
    fiori: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="fiori-default-page fd-has-padding-tiny">
        Page Content: fiori/DefaultPage &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Button
          className="btn-go"
          onClick={() => {
            this.props.history.push('/fiori/forms');
          }}
        >
          Go to forms
        </Button>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    fiori: state.fiori,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultPage);
